module.exports = __webpack_public_path__ + "img/panel-2.81281826.png";